module.exports = ".modal-body {\n  max-height: calc(100vh - 210px);\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/incident-accident/components/incident-accident-edit/incident-accident-edit.component.scss
// module id = ./src/app/incident-accident/components/incident-accident-edit/incident-accident-edit.component.scss
// module chunks = main